import Modal from "components/DesignSystem/Modal/Modal";
import { Button } from "components/DesignSystem/Button/Button";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { useToast } from "hooks/useToast";
import { useDeleteTaxSeasonMutation } from "v2/store/taxSetupApi";
import { useGroupId } from "v2/utils/useGroupId";

type RemoveSeasonModalProps = {
  open: boolean;
  season: number;
  entityId: string;
  entityName: string;
  onClose: () => void;
};

const GENERIC_ERROR = "Something went wrong";

export const RemoveSeasonModal = ({
  open,
  season,
  entityId,
  entityName,
  onClose,
}: RemoveSeasonModalProps) => {
  const { alertToast } = useToast();
  const groupId = useGroupId();

  const [deleteTaxSeason, { isLoading }] = useDeleteTaxSeasonMutation();

  const handleOpenChange = (nextOpen: boolean): void => {
    if (!nextOpen) onClose();
  };

  const handleConfirm = async (): Promise<void> => {
    try {
      await deleteTaxSeason({ groupId, entityId, season }).unwrap();
      onClose();
    } catch (error) {
      const message =
        (error as { data?: { message?: string } })?.data?.message ??
        GENERIC_ERROR;
      alertToast({ message });
    }
  };

  return (
    <Modal.Root open={open} onOpenChange={handleOpenChange}>
      <Modal.Content useCustomOverlay size="small">
        <StatusModal type="warning" title={`Remove season ${season}?`}>
          <div className="t-mt-3 t-flex t-flex-col t-gap-4">
            <span className="t-text-body-sm t-text-text-30">
              This action will remove all filings detected for {entityName} for
              the season {season}. You can add the season back anytime later.
            </span>
          </div>
        </StatusModal>

        <Modal.Footer className="t-flex t-justify-end t-gap-2">
          <Button type="button" customType="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            customType="primary"
            onClick={handleConfirm}
            disabled={isLoading}
            isLoading={isLoading}
          >
            Remove Season {season}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
